import React, { Suspense, useMemo } from 'react';
import { Redirect, Switch, useHistory } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { LayoutSplashScreen, ContentRoute } from "../../../../_metronic/layout";
import { ObjectEdit } from '../../../../_metronic/layout/components/basePage/pages/object-edit/ObjectEdit';
import ObjectsPage from '../../../../_metronic/layout/components/basePage/pages/ObjectsPage';
import { FilterObjectsUIProvider } from '../../../../_metronic/layout/components/basePage/pages/FilterObjectsUIContext';
import { SpecificationsUIProvider } from '../../../../_metronic/layout/components/basePage/insidePages/SpecificationsUIContext';
import { Specifications } from '../../../../_metronic/layout/components/basePage/insidePages/Specifications';

import {
  formFields,
  otherFields,
  initObject,
  ObjectEditSchema,
  columns,
  prepareFilter,
  filterFields,
  filterInitialValues,
} from './FloorUtils';
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import RoomPage from './RoomPage';
import { useBuildingUIContext } from './BuildingUIContext';


export const FloorPage = ({
  basePath,
  history,
  match: {
    params: { id, buildingTitle },
  },
}) => {

  const buildingUIContext = useBuildingUIContext();
  const buildingUIProps = useMemo(() => {
    return {
      buildingId: buildingUIContext.buildingId,
    };
  }, [buildingUIContext]);

  const { currentState } = useSelector(
    (state) => ({ currentState: state.floors }),
    shallowEqual
  );

  let isFullAccess = false;
  const { menuList } = useSelector(
    (state) => ({ menuList: state.auth.menu }),
    shallowEqual
  );

  if (menuList.find(q => q.url == "/building")) {
    const temp = menuList.find(q => q.url == "/building")
    isFullAccess = temp.isFullAccess;
  }


  const backToObjectsList = () => {
    // dispatch(actions.fetchObjectByParentId("api/BankAccountSubGroup", "bankAccountSubGroups", undefined, "subGroupId"));
    history.push(basePath);
  };


  return (
    <FilterObjectsUIProvider initialFilter={filterInitialValues}>
      <SpecificationsUIProvider currentParentId={id} currentParentName="buildingId" initSpecification={initObject}>
        <Card>
          <CardHeader title={`مدیریت طبقات - ${buildingTitle}`} >
            {/* <CardHeader >
            <div className="text-success font-large mt-8">{`مدیریت طبقات - بلوک ${buildingTitle}`} </div> */}
            <CardHeaderToolbar>
              <button
                type="button"
                onClick={backToObjectsList}
                className="btn btn-light"
              >
                <i className="fa fa-arrow-left"></i>
                {"بازگشت به بلوک ها"}
              </button>
            </CardHeaderToolbar>
          </CardHeader>
          <CardBody>
            <Specifications
              showTitle={` ${buildingTitle}`}
              api="api/floor"
              reduxName="floors"
              columns={columns}
              prepareFilter={prepareFilter}
              filterInitialValues={filterInitialValues}
              filterFields={filterFields}
              haveFullAccess={false}
              showRoomsAction={true}
              ObjectEditSchema={ObjectEditSchema}
              formFields={formFields}
              haveEditAction={true}
              haveAddAction={true}
              haveDeleteAction={true}
              haveAccess={false}
              haveHardDelete={true}
              isFullAccess={isFullAccess}
            />
            {/* <FilterObjectsUIProvider initialFilter={filterInitialValues}>
      <Suspense fallback={<LayoutSplashScreen />}>
          <Switch>  */}
            {
              // <Redirect
              //   // exact={true}
              //   from="/building/:id/floors"
              //       to="/building/floors"
              // />

            }
            {/* {
          <Redirect
            // exact={true}
            from="/building/building"
            to="/building/floors"
          />

        } */}
            {/* {
          <Redirect
            // exact={true}
            from="/building/rooms"
            to="/building/floors"
          />
        } */}

            {/* <ContentRoute path="/building/:id/floors/new"
              render={props =>
                <ObjectEdit {...props} isFullAccess={isFullAccess} basePath="/building/:id/floors" api="api/floor" currentState={currentState} initObject={initObject}
                  formFields={formFields} otherFields={otherFields} ObjectEditSchema={ObjectEditSchema} prepareFilter={prepareFilter} />}
            />

            <ContentRoute
                  path="/building/:id/floors/:id/edit"
              render={props =>
                <ObjectEdit {...props} isFullAccess={isFullAccess} basePath="/building/:id/floors" api="api/floor" currentState={currentState} initObject={initObject}
                  formFields={formFields} otherFields={otherFields} ObjectEditSchema={ObjectEditSchema} prepareFilter={prepareFilter} />}
            />  */}

            {/* <ContentRoute
              path="/building/:id/floors/:id/rooms"
              render={props =>
                <RoomPage
                  {...props}
                  isFullAccess={isFullAccess}
                  basePath="/building/:id/floors"
                // api="api/BankAccountSubGroup"
                // currentState={attSettingcurrentState}
                // initObject={initObjectAttendance}
                // formFields={attendanceFormFields}
                // otherFields={otherFields}
                // ObjectEditSchema={ObjectEditSchema}
                // prepareFilter={prepareFilter}
                />}
            /> */}

            {/* <ContentRoute
              // path="/floors"
                  path="/building/:id/floors"
                  render={props => <ObjectsPage parentId={id} prentName="buildingId" isFullAccess={isFullAccess} basePath="/building/:id/floors" api="api/floor" currentState={currentState}
                columns={columns} prepareFilter={prepareFilter} filterFields={filterFields} filterInitialValues={filterInitialValues} />}
            />

          </Switch>
         </Suspense>
    </FilterObjectsUIProvider> */}

          </CardBody>
        </Card>
      </SpecificationsUIProvider >
    </FilterObjectsUIProvider >

  )
}

export default FloorPage



